import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { ProductState } from 'store/product/types';

interface DeselectBundleProductActionPayload {
  bundleGroupId: number;
  productItem: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem;
}

const deselectBundleProductReducer = (
  state: ProductState,
  action: PayloadAction<DeselectBundleProductActionPayload>,
) => {
  const { bundleGroupId, productItem } = action.payload;
  state.selectedBundleProducts = state.selectedBundleProducts.filter(
    (sp) => !(sp.bundleGroupId === bundleGroupId && sp.productId === productItem.productId),
  );
};

export default deselectBundleProductReducer;
